import React, { useEffect,  useState } from "react";

import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import GreyTable from "../../../components/Tables/GreyTable";

import { GroupWiseBalSummery, PartyWiseBalSummery, QualityListwise, QualityWiseBalSummery, resetGroupWiseBalSummery, resetPartyWiseBalSummery, resetQualityWiseBalSummery, resetYearWiseBalSummery, YearWiseBalSummery } from "../../../Redux/Slice/Grey/GreyDashboard/GreyDashboardSlice";
import { Loader } from "../../../components/Loader/Loader";
import DroupdownFilterBox from "../../../components/FilterBox/DroupdownFilterBox";
import { useTheme } from "../../../Themecontext/Themecontext";

export const TotalBalanceMeter = () => {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { YearWiseBalSummerydata, QualityListdata, GroupWiseBalSummerydata, QualityWiseBalSummerydata, PartyWiseBalSummerydata } = useSelector((state) => state.GreyDashboardSlice);
  const { mainFilterData } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;


  useEffect(() => {

    const payload = {
      QualityIds: selectedQualityId ? selectedQualityId.toString() : "",
      partyIDs: selectedAccountId ? selectedAccountId.toString() : "",
      groupIDs: selectedProductionId ? selectedProductionId.toString() : "",
      PgYear: activeTab ? activeTab.toString() : "" // ye sahi hai (array hai)
    };

    dispatch(YearWiseBalSummery({}))
    dispatch(QualityListwise({}))
    dispatch(YearWiseBalSummery(payload));
    dispatch(PartyWiseBalSummery(payload));
    dispatch(GroupWiseBalSummery(payload));
    dispatch(QualityWiseBalSummery(payload));
  }, [dispatch])


  const [selectedProduction, setSelectedProduction] = useState("");
  const [selectedProductionId, setSelectedProductionId] = useState(null);

  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedAccountId, setSelectedAccountId] = useState(null);

  const [selectedQuality, setSelectedQuality] = useState("");
  const [selectedQualityId, setSelectedQualityId] = useState(null);

  const [activeTab, setActiveTab] = useState([]);

  // const [openDropdown, setOpenDropdown] = useState("");
  // const [isHover, setisHover] = useState(false);


  const financialYears =
    (YearWiseBalSummerydata?.AllYear || []).map(
      (item) => item.AllYear
    );



  const handleYearClick = (year) => {
    setActiveTab((prev) =>
      prev.includes(year)
        ? prev.filter((item) => item !== year)
        : [...prev, year],
    );
  };

  const handleSelectAllYears = () => {
    setActiveTab(financialYears);
  };

  const handleClearAllYears = () => {
    setActiveTab([]);
  };

  const handleSubmitFilter = () => {
    dispatch(resetGroupWiseBalSummery())
    dispatch(resetPartyWiseBalSummery())
    dispatch(resetQualityWiseBalSummery())
    dispatch(resetYearWiseBalSummery())
    const payload = {
      QualityIds: selectedQualityId ? selectedQualityId.toString() : "",
      partyIDs: selectedAccountId ? selectedAccountId.toString() : "",
      groupIDs: selectedProductionId ? selectedProductionId.toString() : "",
      PgYear: activeTab ? activeTab.toString() : "" // ye sahi hai (array hai)
    };

    dispatch(YearWiseBalSummery(payload));
    dispatch(PartyWiseBalSummery(payload));
    dispatch(GroupWiseBalSummery(payload));
    dispatch(QualityWiseBalSummery(payload));
  };


  const tableData1 = (YearWiseBalSummerydata?.data || []).map(
    (row, index) => ({
      AllYear: row.AllYear,
      Meter: row.Meter,
      Taka: row.Taka,
    })
  );

  const columns1 = [
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: "Fc Year",
      key: "AllYear",
      align: "right",
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: "Total Meter",
      key: "Meter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: `Total Taka`,
      key: "Taka",
      align: "right",
      rupees: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    }
  ];

  const tableData2 = (GroupWiseBalSummerydata?.data || []).map(
    (row, index) => ({
      // srNumber: index + 1,
      ProductionGroupMstName: row.ProductionGroupMstName,
      Meter: row.Meter,
      Taka: row.Taka,
    })
  );

  const columns2 = [
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: "Production Name",
      key: "ProductionGroupMstName",
      align: "Left",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: "Total Meter",
      key: "Meter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: `Total Taka`,
      key: "Taka",
      align: "right",
      rupees: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    }
  ];

  const tableData3 = (PartyWiseBalSummerydata?.data || []).map(
    (row, index) => ({
      // srNumber: index + 1,
      AcName: row.AcName,
      Meter: row.Meter,
      Taka: row.Taka,
    })
  );

  const columns3 = [
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: "Ac Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: "Total Meter",
      key: "Meter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: `Total Taka`,
      key: "Taka",
      align: "right",
      rupees: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    }
  ];

  const tableData4 = (QualityWiseBalSummerydata?.data || []).map(
    (row, index) => ({
      // srNumber: index + 1,
      ItemName: row.ItemName,
      Meter: row.Meter,
      Taka: row.Taka,
    })
  );

  const columns4 = [
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: "Quality Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: "Total Meter",
      key: "Meter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: `Total Taka`,
      key: "Taka",
      align: "right",
      rupees: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    }
  ];

  const commonButtonStyle = {
    minWidth: "110px",
    fontSize: "0.9375rem",
    padding: "8px",
    backgroundColor:
      isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour6,
    color: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : "rgba(149, 213, 178, 0.25"}`,
    borderRadius: "20px",
    cursor: "pointer",
    fontWeight: "700",
  };



  if (!mainFilterData || !QualityListdata) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }

  if (GroupWiseBalSummerydata === null) {
    return (
      <div className=" flex justify-center items-center h-screen text-xl " >
        <Loader />
      </div>
    );
  }

  if (QualityWiseBalSummerydata === null) {
    return (
      <div className=" flex justify-center items-center h-screen text-xl " >
        <Loader />
      </div>
    );
  }

  if (PartyWiseBalSummerydata === null) {
    return (
      <div className=" flex justify-center items-center h-screen text-xl " >
        <Loader />
      </div>
    );
  }

  if (YearWiseBalSummerydata === null) {
    return (
      <div className=" flex justify-center items-center h-screen text-xl " >
        <Loader />
      </div>
    );
  }



  return (
    <>
      <style>{`
        .filter-scrollbar::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .filter-scrollbar::-webkit-scrollbar-track {
          background: var(--theme-scrollbar-track, #e6e6e6);
          border-radius: 10px;
        }

        .filter-scrollbar::-webkit-scrollbar-thumb {
          background: var(--theme-scrollbar-thumb, rgb(64, 145, 108));
          border-radius: 10px;
        }

        .filter-scrollbar::-webkit-scrollbar-thumb:hover {
          background: var(--theme-scrollbar-thumb-hover, rgb(44, 125, 88));
        }
      `}</style>

      <div className="pageContainer">
        <Row className="g-4">

          {/* 🔷 FILTER SECTION */}
          <Col xs={12}>
            <div
              style={{
                background:
                  isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour10,
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px",
                padding: "15px",
                // borderRadius: "16px",
                borderRadius: "12px",
                border: `2px solid ${isdark === "light"
                  ? iscolour?.Colour4
                  : iscolourDark?.Colour3
                  }`,
              }}
            >
              <Row className="g-3">

                {/* 🔷 YEAR BUTTONS */}
                <Col xs={12}>
                  <Row className="align-items-center g-2">

                    {/* LEFT BUTTONS */}
                    <Col lg={8} md={12} sm={12}>
                      <div className="d-flex flex-wrap gap-2">
                        {financialYears.length > 0 ? (
                          financialYears.map((tab) => (
                            <button
                              key={tab}
                              onClick={() => handleYearClick(tab)}
                              style={{
                                ...commonButtonStyle,
                                backgroundColor: activeTab.includes(tab)
                                  ? "rgb(64, 145, 108)"
                                  : commonButtonStyle.backgroundColor,
                                color: activeTab.includes(tab)
                                  ? "#fff"
                                  : commonButtonStyle.color,
                              }}
                            >
                              {tab}
                            </button>
                          ))
                        ) : (
                          <p>Loading...</p>
                        )}
                      </div>
                    </Col>

                    {/* RIGHT BUTTONS */}
                    <Col lg={4} md={12} sm={12}>
                      <div className="d-flex justify-content-lg-end gap-2 flex-wrap">
                        <button onClick={handleSelectAllYears} style={commonButtonStyle}>
                          Select All
                        </button>
                        <button onClick={handleClearAllYears} style={commonButtonStyle}>
                          Clear All
                        </button>
                      </div>
                    </Col>

                  </Row>
                </Col>

                <Col xl={4} lg={6} md={6} sm={12} >
                  <DroupdownFilterBox
                    label="Production Name"
                    data={mainFilterData?.production_Group_Master_List?.map((item) => ({
                      label: item.ProductionGroupMstName,
                      value: item.ProductionGroupMstID,
                    }))}
                    selectedValue={selectedProduction}
                    setSelectedValue={setSelectedProduction}
                    selectedId={selectedProductionId}
                    setSelectedId={setSelectedProductionId}
                    placeholder="Select Production Group(s)"
                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}
                  />
                </Col>
                <Col xl={4} lg={6} md={6} sm={12} className="pt-0 pt- " >

                  <DroupdownFilterBox
                    label="Account Name"
                    data={mainFilterData?.account_list?.map((item) => ({
                      label: item.AcName,
                      value: item.AcID,
                    }))}
                    selectedValue={selectedAccount}
                    setSelectedValue={setSelectedAccount}
                    selectedId={selectedAccountId}
                    setSelectedId={setSelectedAccountId}
                    placeholder="Select Account Name(s)"
                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}
                  />

                </Col>
                <Col xl={4} lg={6} md={6} sm={12} >
                  <DroupdownFilterBox
                    label="Quality Name"
                    data={QualityListdata?.Quality?.map((item) => ({
                      label: item.ItemName,
                      value: item.ItemID
                    }))}
                    selectedValue={selectedQuality}
                    setSelectedValue={setSelectedQuality}
                    selectedId={selectedQualityId}
                    setSelectedId={setSelectedQualityId}
                    placeholder="Select Quality Name(s)"
                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}

                  />

                </Col>



                {/* 🔷 SUBMIT BUTTON */}
                <Col xs={12} className="text-center mt-3">
                  <button
                    onClick={handleSubmitFilter}
                    className="hover-scale-btn"
                    style={{
                      padding: "12px",
                      backgroundColor: "rgb(64, 145, 108)",
                      color: "#fff",
                      width: "100%",
                      border: "1px solid rgb(64, 145, 108)",
                      borderRadius: "10px",
                      // fontSize: "15px",
                      fontWeight: "700",
                      cursor: "pointer",
                      boxSizing: "border-box",
                    }}
                  >
                    Apply Filter
                  </button>
                </Col>

              </Row>
            </div>
          </Col >

          {/* 🔷 TABLE 1 */}
          < Col xs={12} >
            <div style={{ borderRadius: "16px", overflow: "hidden", boxShadow: "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px" }}>
              < div
                style={{
                  backgroundColor:
                    isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                  color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,

                  padding: "14px",
                  margin: 0,
                }}
              >
                <h2
                  className="text-xl font-semibold tracking-wide"
                  style={{
                    fontSize: "18Px",
                    margin: 0,
                    letterSpacing: "1px",
                    fontWeight: "700"
                  }}
                >
                  YEARWISE BALANCE METER
                </h2>
              </div>

              <div
                style={{
                  backgroundColor: "rgb(255, 255, 255)",
                  margin: 0,
                }}
              >
                <GreyTable columns={columns1} data={tableData1} iscolourDark={iscolourDark}
                  iscolour={iscolour} />
              </div>
            </div>
          </Col >

          {/* 🔷 TABLE 2 */}
          < Col xs={12} >
            <div style={{ borderRadius: "16px", overflow: "hidden", boxShadow: "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px" }}>
              <div
                style={{
                  backgroundColor:
                    isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                  color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                  padding: "14px",
                  margin: 0,
                }}
              >
                <h2
                  className="text-xl font-semibold tracking-wide"
                  style={{
                    fontSize: "18Px",
                    margin: 0,
                    letterSpacing: "1px",
                    fontWeight: "700"
                  }}
                >     MASTERWISE BALANCE METER
                </h2>
              </div>

              <div
                style={{
                  backgroundColor: "rgb(255, 255, 255)",
                  margin: 0,
                }}
              >
                <GreyTable columns={columns2} data={tableData2} iscolourDark={iscolourDark}
                  iscolour={iscolour} />
              </div>
            </div>
          </Col >

          {/* 🔷 TABLE 3 */}
          < Col xs={12} >
            <div style={{ borderRadius: "16px", overflow: "hidden", boxShadow: "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px" }}>
              <div
                style={{
                  backgroundColor:
                    isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                  color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                  padding: "14px",
                  margin: 0,
                }}
              >
                <h2
                  className="text-xl font-semibold tracking-wide"
                  style={{
                    fontSize: "18Px",
                    margin: 0,
                    letterSpacing: "1px",
                    fontWeight: "700"
                  }}
                >     PARTYWISE BALANCE METER
                </h2>
              </div>

              <div
                style={{
                  backgroundColor: "rgb(255, 255, 255)",
                  margin: 0,
                }}
              >
                <GreyTable columns={columns3} data={tableData3} iscolourDark={iscolourDark}
                  iscolour={iscolour} />
              </div>
            </div>
          </Col >

          {/* 🔷 TABLE 4 */}
          < Col xs={12} >
            <div style={{ borderRadius: "16px", overflow: "hidden", boxShadow: "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px", }}>
              <div
                style={{
                  backgroundColor:
                    isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                  color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                  padding: "14px",
                  margin: 0,
                }}
              >
                <h2
                  className="text-xl font-semibold tracking-wide"
                  style={{
                    fontSize: "18Px",
                    margin: 0,
                    letterSpacing: "1px",
                    fontWeight: "700"
                  }}
                >
                  QUALITYWISE BALANCE METER
                </h2>
              </div>

              <div
                style={{
                  backgroundColor: "rgb(255, 255, 255)",
                  margin: 0,
                }}
              >
                <GreyTable columns={columns4} data={tableData4} iscolourDark={iscolourDark}
                  iscolour={iscolour} />
              </div>
            </div>
          </Col >

        </Row >
      </div >
    </>
  );
};


